import { forwardRef, type PropsWithChildren } from 'react';
import { AccordionItemContent, AccordionItems, AccordionSkeleton } from './accordion.shared';
import type { AccordionItemProps, AccordionProps } from './types';

function Frame({ children }: PropsWithChildren) {
  return (
    <div className="w-full overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm">
      {children}
    </div>
  );
}

export function Accordion(props: AccordionProps) {
  return (
    <Frame>
      <AccordionItems>{props.children}</AccordionItems>
    </Frame>
  );
}

const AccordionItem = forwardRef<HTMLDivElement, AccordionItemProps>(
  function AccordionItem(props, ref) {
    return <AccordionItemContent ref={ref} {...props} />;
  },
);

function AccordionSkeletonFramed(props: { count?: number }) {
  return (
    <Frame>
      <AccordionSkeleton {...props} />
    </Frame>
  );
}

Accordion.Item = AccordionItem;
Accordion.Skeleton = AccordionSkeletonFramed;
